module.exports = {
    remoteDingtalkUrl: 'https://www.hzmetro.online:8443/dingtalk_server', // 正式
    javaUrl: 'https://hzmetro-b-app.mtros.cn:9003/disinfection/', // 正式
    agentId: '1083910581', // 正式
    corpid: 'dingf18a38c956b37f53' // 正式
    // remoteDingtalkUrl: 'https://www.hzmetro.online:18443/dingtalk_server', // 测试
    // javaUrl: 'http://47.110.155.104:15100/disinfection/', // 测试
    // agentId: '202504026', // 测试
    // corpid: 'ding1b71ecf170076fec' // 测试
}



// WEBPACK FOOTER //
// ./src/env.js